import { render, staticRenderFns } from "./AccountSettingSocial.vue?vue&type=template&id=03c34e2c"
import script from "./AccountSettingSocial.vue?vue&type=script&lang=js"
export * from "./AccountSettingSocial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports